<template>
  <div class="dataset-edit-dailog dialog col-block">
    <div class="main-container col-block width-full">
      <datasetBase
        :ref="'main'"
        :defaultData="dataset"
        :form="{}"
        @onError="error => onError = error"
        @unloadAlert="alert => unloadAlert = alert"
      ></datasetBase>
    </div>
    <div class="sharing-container col-block width-full">
      <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
      <customForm
        :layoutType="'grid'"
        :groupCount="6"
        :displayMode="true"
        :init="{}"
        :alerts="{}"
        :forms="formOptions['field1']"
        @change="(result, validate, errors) => {}"
      >
        <template slot="_SHAREALERT" slot-scope="props">
          <div :name="props" class="_SHAREALERT row-block flex-start">
            <div
              class="content break-line shrink"
              v-html="[
                '<b>Not available</b>'/* ___ */,
                dataset.shareAlert
              ].join('<br>')"
            ></div>
            <div :style="{ flex: 1 }"></div>
          </div>
        </template>
        <template slot="_SHARING" slot-scope="props">
          <div :name="props" class="_SHARING row-block flex-start">
            <div
              class="content break-line shrink"
              v-html="[
                'Community:'/* ___ */,
                datasetPermissionMap[dataset.community_permission].title
              ].join('<br>')"
            ></div>
            <div :style="{ flex: 1 }"></div>
            <button type="button" class="white-gray-button circle-button" @click="e => $emit('changeModal', {}, { tab: 'share' })">
              <span>{{ 'Share setting'/* ___ */ }}</span>
            </button>
            <div :style="{ width: '10px' }"></div>
          </div>
        </template>
        <template slot="_URL" slot-scope="props">
          <div :name="props" class="_URL row-block">
            <div
              class="content break-line shrink"
              v-html="[
                dataset.url
              ].join('<br>')"
            ></div>
            <div :style="{ width: '10px' }"></div>
            <div class="icon-block" :title="'Copy'/* ___ */" :style="{ '--size': '20px' }" @click="e => copyDatasetUrl()">
              <img :src="require('../../assets/images/copy-icon.svg')" alt="">
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
        </template>
        <template slot="_USER" slot-scope="props">
          <div :name="props" class="_USER row-block">
            <div
              class="content break-line shrink"
              :style="{ flex: 1 }"
              v-html="[
                dataset.shares.length + ' user' + (dataset.shares.length > 1 ? 's' : '')/* ___ */
              ].join('<br>')"
            ></div>
          </div>
        </template>
        <template slot="_KEY" slot-scope="props">
          <div :name="props" class="_KEY row-block">
            <div
              class="content break-line shrink"
              :style="{ flex: 1 }"
              v-html="[
                dataset.access_key || '- -'
              ].join('<br>')"
            ></div>
          </div>
        </template>
      </customForm>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Cancel'/* ___ */ }}</span>
      </button>
      <div :style="{ width: '16px' }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit && validateEditDataset()">
        <span>{{ 'Update'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getDatasetPictureFile, postDatasetPictureFile, putDataset } from '../../api'
import datasetBase from '../dataset/base.vue'
import customForm from '../tool/customForm.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import { datasetPermissionMap } from '../../constants/global/data'

export default {
  components: {
    datasetBase,
    customForm
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataset: null,
      onError: false,
      onSubmit: false,
      // alert
      unloadAlert: false
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    // static
    formOptions () {
      return {
        field1: this.dataset.shareAlert ? [
          {
            title: 'Sharing'/* ___ */,
            value: '_SHAREALERT',
            type: 'custom',
            grid: 6
          }
        ] : [
          {
            title: 'Sharing'/* ___ */,
            value: '_SHARING',
            type: 'custom',
            grid: 2
          },
          {
            title: 'Dataset URL'/* ___ */,
            value: '_URL',
            type: 'custom',
            grid: 4
          },
          {
            title: 'Users'/* ___ */,
            value: '_USER',
            type: 'custom',
            grid: 2
          },
          {
            title: 'Access Key'/* ___ */,
            value: '_KEY',
            type: 'custom',
            grid: 4
          }
        ]
      }
    },
    // global
    datasetPermissionMap () { return datasetPermissionMap }
  },
  watch: {
    // unload alert
    'unloadAlert' (nv) {
      if (nv) {
        this.setUnloadAlertAction(true)
      } else {
        this.setUnloadAlertAction(false)
      }
    }
  },
  created () {
    this.dataset = { ...this.param.defaultData }
  },
  beforeDestroy () {
    this.setUnloadAlertAction(false)
  },
  methods: {
    ...mapActions([
      'setUnloadAlertAction'
    ]),
    copyDatasetUrl () {
      navigator.clipboard.writeText(this.dataset.url)
    },
    async validateEditDataset () {
      this.onSubmit = true
      try {
        const forms = Object.values(this.$refs).map(ref => ref[0] || ref)
        let success = true
        for (let form of forms) {
          let result = await form.validateSubmit()
          if (form && !result) {
            success = false
          }
        }
        if (success) {
          let datas = []
          for (let form of forms) {
            let data = await form.submit()
            if (form && !data) {
              throw new Error()
            } else {
              datas.push(data)
            }
          }
          await this.editDataset(datas[0])
        }
      } catch (error) {
      }
      this.onSubmit = false
    },
    async editDataset (formData) {
      try {
        let config = this.$ls.get('userInfo')
        let id = this.dataset.id
        let data = formData.data
        if (['custom'].includes(data.dataset_picture_file_id) && formData.customPicture) {
          let file = await this.uploadCustomPicture(this.dataset, formData.customPicture)
          data.dataset_picture_file_id = file.id
        }
        let response = await putDataset(id, data, config)
        let dataset = response.data.data
        // this.addToast('success', response.data.result.message)
        this.$emit('changeModal', {}, dataset)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    },
    async uploadCustomPicture (dataset, customPicture) {
      try {
        let config = this.$ls.get('userInfo')
        let id = dataset.id
        let data = {
          name: customPicture.name,
          content_type: customPicture.file.type
        }
        let response = await postDatasetPictureFile(id, data, config)
        let url = response.data.data.url
        let result = await this.uploadPictureFile(url, customPicture.file)
        if (result) {
          let file = await this.getCustomPicture(id)
          return file
        }
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    },
    async uploadPictureFile (url, file) {
      let result = await new Promise(resolve => {
        let xhr = this.createCORSRequest('PUT', url)
        if (xhr.upload) {
          xhr.onload = () => { resolve(true) }
          xhr.onerror = () => { resolve(true) }
          xhr.setRequestHeader('Content-Type', file.type)
          xhr.send(file)
        } else {
          this.addToast('error', 'Xhr can not upload.'/* ___ */)
        }
      })
      return result
    },
    async getCustomPicture (id) {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getDatasetPictureFile(id, config)
        let file = response.data.data
        return file
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    },
    createCORSRequest (method, url) {
      let xhr = new XMLHttpRequest()
      if ('withCredentials' in xhr) {
        xhr.open(method, url, true)
      } else if (typeof XDomainRequest !== 'undefined') {
        xhr = new XDomainRequest()
        xhr.open(method, url)
      } else {
        xhr = null
      }
      return xhr
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/datasetEdit.vue